import { render } from "./PermitsMenuNotFound.vue?vue&type=template&id=69a66b6b"
import script from "./PermitsMenuNotFound.vue?vue&type=script&lang=js"
export * from "./PermitsMenuNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__